import moment from 'moment';

export const timerCounter = (date: moment.Moment) => {
  const daysToExpire = date.diff(moment());
  const eventDate = moment.duration(daysToExpire);
  const days = eventDate.months() * 31 + eventDate.days();
  const hours = eventDate.hours();
  const mins = eventDate.minutes();
  const secs = eventDate.seconds();
  return {days, hours, mins, secs};
};

export const timerString = (timer: {
  hours: number;
  mins: number;
  secs: number;
}) => {
  if (timer.secs < 0 || (!timer.secs && !timer.hours && !timer.mins)) return '';
  else if (timer.hours) return `${timer.hours}h ${timer.mins}m ${timer.secs}s`;
  return `${timer.mins}m ${timer.secs}s`;
};

export const timerStringInDigits = (timer: {
  hours: number;
  mins: number;
  secs: number;
}) => {
  if (timer.secs < 0 || (!timer.secs && !timer.hours && !timer.mins)) return '';
  else if (timer.hours)
    return `${String(timer.hours).padStart(2, '0')}:${String(
      timer.mins,
    ).padStart(2, '0')}:${String(timer.secs).padStart(2, '0')}`;
  return `${String(timer.mins).padStart(2, '0')}:${String(timer.secs).padStart(
    2,
    '0',
  )}`;
};
